import React from 'react';
import * as images from '../../website/images';
import s from '../style.css';
const DevicesImage = () => {
    return (React.createElement("div", null,
        React.createElement("img", { src: images.iphone, className: s.iphone, alt: 'iPhone' }),
        React.createElement("img", { src: images.android, className: s.android, alt: 'Android' })));
};
export default DevicesImage;
